var appVersion = "v1.1.0.3";
var app = angular.module(
  'app', [
        'pascalprecht.translate',
        'ui.router',
        'angularConfigurationManager',
        'toastr', 'angular-loading-bar',
        'ui.bootstrap',
        '720kb.datepicker',
        'ngScrollbars',
        'duScroll',
        'ngRoute',
        'angular-sly',
        'monospaced.elastic',
        'ckeditor',
        'ngOutsideClick',
        'perfect_scrollbar',
        'rzModule',
        'angularUtils.directives.dirPagination',
        'diff-match-patch',
        'angucomplete',
        'tableSort',
         'ui.sortable',
        'ngFileUpload',
        'ngMap',
        'slickCarousel',
        'tmh.dynamicLocale',
        'angular.filter'
         //'wu.masonry'
  ]
).config(
  [
    'cfpLoadingBarProvider',
    function (cfpLoadingBarProvider) {
        cfpLoadingBarProvider.includeSpinner = false;
    }
  ]
).config(function (toastrConfig) {
    angular.extend(toastrConfig, {
        positionClass: 'toast-center',
        //autoDismiss: false,
        //maxOpened: 10,
        //newestOnTop: true,
        progressBar: false,
        target: '.container-toast',
        //target: '#container-body',
        extendedTimeOut: 1000,
        timeOut: 10000
    });
}).config(function (ScrollBarsProvider) {
    ScrollBarsProvider.defaults = {
        scrollButtons: {
            scrollAmount: 'auto', // scroll amount when button pressed
            enable: true // enable scrolling buttons by default
        },
        scrollInertia: 400, // adjust however you want
        axis: 'xy', // enable 2 axis scrollbars by default
        theme: 'dark-thin',
        autoHideScrollbar: true
    };
    })
.config(['$translateProvider',
        function ($translateProvider) {
            $translateProvider.translations('en', {
                "BienvenueEmailTitle": "Welcome to the Louis Vuitton City Guides Content Platform!",
            })
            $translateProvider.translations('fr', {
                "BienvenueEmailTitle": "Bienvenue sur la Content Platform Louis Vuitton City Guides !",
            })
            $translateProvider.useStaticFilesLoader(
                {
                    prefix: 'application/translation/LouisVuitton_',
                    suffix: '.json'
             })
            //.preferredLanguage('fr');

            //$translateProvider.useSanitizeValueStrategy('escape');
            $translateProvider.useSanitizeValueStrategy('sceParameters');
            $translateProvider.forceAsyncReload(true);
            $translateProvider.useLoaderCache('$templateCache');
        //    $translateProvider.useMissingTranslationHandler('customTranslationHandler');
        }

])
.config(function(tmhDynamicLocaleProvider) {
    tmhDynamicLocaleProvider.localeLocationPattern('bower_components/angular-i18n/angular-locale_{{locale}}.js');

});

app.factory('customTranslationHandler', function () {
    return function (translationID) {
        return "." + translationID;
    };
});

app.factory('asyncLoader', function ($q, $timeout) {

    return function (options) {
        var deferred = $q.defer(),
            translations;

        if (options.key === 'key') {
            translations = {
                "key":"",
            };
        } 
        return deferred.promise;
    };
});

app.config(['$provide', Decorate]);
function Decorate($provide) {
    $provide.decorator('$templateCache',
        ['$delegate', function ($delegate) {
            var templateCache = $delegate;

            var normalGet = templateCache.get;
            var normalPut = templateCache.put;
            templateCache.get = function (key) { return normalGet(key.toLowerCase()); };
            templateCache.put = function (key, value) { normalPut(key.toLowerCase(), value); };

            return $delegate;
        }]);
}


var appexport = angular.module(
  'appexport', [
        'pascalprecht.translate',
        'ui.router',
        'angularConfigurationManager',
        'ui.bootstrap',
        'ngRoute',
        'tableSort',
  ]
)
.config(['$translateProvider',
        function ($translateProvider) {

            $translateProvider.useStaticFilesLoader({

                prefix: 'application/translation/LouisVuitton_',
                suffix: '.json'
            })
            .preferredLanguage('fr');

            $translateProvider.useSanitizeValueStrategy('escape');
            $translateProvider.useLoaderCache('$templateCache');
        }

])

appexport.config(['$provide', Decorate]);
function Decorate($provide) {
    $provide.decorator('$templateCache',
        ['$delegate', function ($delegate) {
            var templateCache = $delegate;

            var normalGet = templateCache.get;
            var normalPut = templateCache.put;
            templateCache.get = function (key) { return normalGet(key.toLowerCase()); };
            templateCache.put = function (key, value) { normalPut(key.toLowerCase(), value); };

            return $delegate;
        }]);
}

